import {
  createContext,
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
} from "react";
import "./styles.css";
import { AxiosError } from "axios";
import ServiceError from "../../service/error";
import { ApiError } from "../../api";

export const ErrorMessageContext = createContext<
  [string, Dispatch<SetStateAction<string>>]
>(["", () => {}]);

export function useSetErrorMessage() {
  const context = useContext(ErrorMessageContext);
  return (message: string) => {
    context[1](message);
  };
}

export function errorToString(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  } else if (error instanceof AxiosError) {
    if (error.response) {
      return (
        error.response.status +
        " " +
        error.response.statusText +
        ": " +
        error.response.data
      );
    } else return "No internet " + (error.code ?? "error");
  } else if (error instanceof Error) {
    return error.message;
  } else return String(error);
}

export function useSetError() {
  const setErrorMessage = useSetErrorMessage();
  const callback = useCallback(
    (error: unknown) => setErrorMessage(errorToString(error)),
    [setErrorMessage]
  );
  return callback;
}
export function useErrorMessage() {
  return useContext(ErrorMessageContext)[0];
}

function GenericErrorDisplay({ error }: { error: any }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <div className="generic-error">
      {error instanceof AxiosError ? (
        <>
          {error.response ? (
            <>
              <h3>{error.response.status + " " + error.response.statusText}</h3>
              <p>{error.response.data}</p>
            </>
          ) : error.request ? (
            <>
              <h3>Server down</h3>
              <p>{error.request.data}</p>
            </>
          ) : (
            <>
              <h3>Error</h3>
            </>
          )}
          <i>Axios code: {error.code}</i>
          <p>Message: {error.message}</p>
        </>
      ) : error instanceof ServiceError ? (
        <>
          <h3>Service error: {error.title}</h3>
          <p>{error.body}</p>
        </>
      ) : error instanceof ApiError ? (
        <>
          <h3>Server error {error.status}</h3>
          <p>{error.message}</p>
        </>
      ) : (
        <>
          <h3>Error</h3>
          <p>{error.toString()}</p>
        </>
      )}
    </div>
  );
}

export default GenericErrorDisplay;
